export const environments = {
  domain: "https://library-backend.ky4trb.easypanel.host",
  tokenKey: "CIU-User",
  themeSelected: "themeSelected",
  colorSchemeSelected: "colorSchemeSelected",
};
